import React from 'react';
import Badge from '@atlaskit/badge';
import {
	ORIGINAL_ESTIMATE_INLINE_READ_EDIT_VIEW_BADGE,
	ORIGINAL_ESTIMATE_INLINE_EDIT_READ_VIEW_WRAPPER,
} from '../common/constants';
import { BadgeWrapper } from './styled';

type Props = {
	isEditable?: boolean;
	value: string;
};

export const OriginalEstimateReadView = ({ isEditable = false, value }: Props) => (
	<BadgeWrapper
		data-testid={ORIGINAL_ESTIMATE_INLINE_EDIT_READ_VIEW_WRAPPER}
		isEditable={isEditable}
	>
		<Badge testId={ORIGINAL_ESTIMATE_INLINE_READ_EDIT_VIEW_BADGE}>{value}</Badge>
	</BadgeWrapper>
);
